<template>
  <div>
    <button
      class="btn btn-outline-dark ga__report-btn"
      @click.stop="onClick"
      :class="{ disabled, mobile: isMobile }"
    >
      <span>{{ recurringExpression ? 'Report options' : 'Get report' }}</span>
      <i class="icon-download" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: ['disabled'],
  computed: {
    ...mapGetters(['isMobile']),
    ...mapGetters('dataStore', ['recurringExpression'])
  },
  methods: {
    onClick() {
      if (this.disabled) {
        this.$store.dispatch('showReportWarning');
        return;
      }
      if (this.$tours['reportTour']) {
        this.$tours['reportTour'].skip();
      }
      this.$store.commit('setShowReportModal', true);
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid black;
  color: #1a1a1a;
  background-color: white;
  padding: 0 0.5rem;

  i {
    font-size: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    width: auto;
    margin-left: 0.5rem;
  }
  &.disabled {
    border-color: #ccc;
    color: #ccc;
    opacity: 1;
    cursor: not-allowed;
  }
  @include for-tablet-portrait-down {
    i {
      margin: 0;
      font-size: 24px;
    }
  }
}

.mobile {
  width: 9rem;

  span {
    font-size: 0.8rem;
  }

  i {
    margin-left: 0.5rem;
    font-size: 1rem;
  }
}
</style>
